import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/697c0d60921dc900144a1c6b/mindshift_ai/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697c0d60921dc900144a1c6b/mindshift_ai/src/app/partnership-inquiry/components/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697c0d60921dc900144a1c6b/mindshift_ai/src/app/partnership-inquiry/components/InquiryForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697c0d60921dc900144a1c6b/mindshift_ai/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/697c0d60921dc900144a1c6b/mindshift_ai/src/components/ui/AppIcon.tsx");
